import React from "react";
import { Button, Icon } from "semantic-ui-react";
import "./zoomstyle.scss";

function ZoomSlider({
  scaleValue,
  scaleChange,
  minScaleValue,
  rotateDocument,
  disableRotation,
  docs,
}) {
  const onSlide = (e) => {
    scaleChange(Number(e.target.value));
  };
  return (
    <div className="zoom-slider-container">
      <div
        className="zoom-slider-btn"
        onClick={() => scaleChange((scaleValue || 0.18999) + 0.05)}
      >
        <Icon name="plus" />
      </div>
      <div className="slider-container">
        <input
          className="slider"
          type={"range"}
          orient={"vertical"}
          value={Number(scaleValue)}
          min={0.18999}
          max={0.8}
          onChange={onSlide}
          step={0.05}
        />
        <span onClick={() => scaleChange(minScaleValue)}>
          <Icon name="refresh" />
        </span>
      </div>
      <div
        className="zoom-slider-btn"
        onClick={() => scaleChange(scaleValue - 0.05)}
      >
        <Icon name="minus" />
      </div>
    { docs ? (
        <div className="rotation">
          <div className="left-rotation">
            <Icon name="undo"  onClick={rotateDocument} disabled={disableRotation} />
          </div>
          <div className="right-rotation">
            <Icon name="redo" onClick={rotateDocument?.bind(null,{ isAntiClockwise: true })} disabled={disableRotation}/>
          </div>
        </div>
    ) : null}
    </div>
  );
}

export default ZoomSlider;
